import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=9012bff8&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"
import style0 from "../styles/AlertModal.css?vue&type=style&index=0&id=9012bff8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9012bff8",
  null
  
)

export default component.exports